import React from "react";
import PageShell from "@/components/PageShell";
import { RotateCcw } from "lucide-react";

const INTRO =
  "شكرًا لاهتمامك بشراء منتجاتنا الرقمية. يرجى مراجعة سياسة الشراء والاسترجاع التالية قبل الشراء:";

const ITEMS = [
  {
    title: "عدم وجود استبدال أو استرجاع",
    body:
      "نظرًا للطبيعة الرقمية للمنتج، لا يُقبل استبدال أو استرجاع الكتب الرقمية بمجرد إتمام عملية الشراء.",
  },
  {
    title: "حقوق الملكية الفكرية",
    body:
      "جميع المنتجات الرقمية محمية بحقوق الملكية الفكرية. يُمنع بشدة نسخ أو توزيع المنتجات الرقمية دون الحصول على إذن صريح من الناشر. جميع الحقوق محفوظة للمؤلف.",
  },
  {
    title: "الاستخدام الشخصي",
    body:
      "يحق للمشتري فقط استخدام المنتج الرقمي، ويتعهد بعدم توزيع الكتاب أو بيعه أو إعادة نشره أو إرساله أو نقله أو مشاركته مع الآخرين بأي شكل من الأشكال وبأي وسيلة كانت.",
  },
  {
    title: "عملية الشراء والتسليم",
    body:
      "المنتج يسلم بشكل فوري وتلقائي بعد إتمام الدفع عبر صفحة تفاصيل الطلب والبريد الإلكتروني.",
  },
  {
    title: "المسؤولية والتعويض",
    body:
      "لا يتحمل الموقع أي مسؤولية لمشتريات خاطئة قمت بها بذاتك، بسبب إهمال أو إدخال معلومات خاطئة أثناء عملية الشراء مثل عنوان البريد الإلكتروني. وعليه فإن الموقع غير ملزم بالتعويض عن أي خسائر مادية تنتج عن هذه المشتريات الخاطئة.",
  },
  {
    title: "بعد التسليم",
    body:
      "الموقع ليس مسؤولاً عن أي فقدان للسلعة الرقمية التي تم شراؤها بعد تسليمها.",
  },
];

const RefundPolicy = () => (
  <PageShell>
    <section
      className="max-w-3xl mx-auto px-6 lg:px-12 py-16"
      data-testid="refund-policy-page"
    >
      <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full bg-[#F6F4EE] border border-[#E5E1D8] text-[#0A4D3C] text-sm">
        <RotateCcw className="w-4 h-4" /> سياسة الشراء والاسترجاع
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl text-[#222222] mt-6">
        سياسة الشراء والاسترجاع
      </h1>
      <p className="text-[#5E5C58] mt-4 leading-loose">{INTRO}</p>

      <div
        className="mt-10 rounded-2xl border border-[#E5E1D8] bg-[#FAF9F6] p-6 sm:p-8"
        data-testid="refund-policy-card"
      >
        <ul className="list-disc ps-6 space-y-5 text-[#222222] leading-loose text-base">
          {ITEMS.map((it, i) => (
            <li key={i} data-testid={`refund-item-${i + 1}`}>
              <span className="font-semibold text-[#0A4D3C]">{it.title}: </span>
              {it.body}
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-10 text-sm text-[#5E5C58] leading-relaxed">
        لأي استفسار بخصوص الشراء أو الاسترجاع، يمكنك التواصل مع{" "}
        <span className="font-semibold text-[#222222]">خدمة العملاء</span> عبر الواتساب على{" "}
        <a
          href="https://wa.me/966538278484"
          target="_blank"
          rel="noopener noreferrer"
          dir="ltr"
          className="text-[#1ebe5b] hover:text-[#159b48]"
          data-testid="refund-policy-whatsapp-link"
        >
          +966 53 827 8484
        </a>
        .
      </p>
    </section>
  </PageShell>
);

export default RefundPolicy;
